/* global axios */
import ApiClient from './ApiClient';

class ContactImportsAPI extends ApiClient {
  constructor() {
    super('contact_imports', { accountScoped: true });
  }

  get(page = 1) {
    return axios.get(this.url, { params: { page } });
  }

  getFailedRecords(id) {
    return axios.get(`${this.url}/${id}/failed_records`, {
      responseType: 'blob',
    });
  }
}

export default new ContactImportsAPI();
